import React from 'react'
import useMediaQuery from '@mui/material/useMediaQuery'
import Head from 'next/head'
import usePageProps from 'hooks/usePageProps'
import { useRouter } from 'next/router'
import { removeHtmlFromString } from 'utils/universal'
import get from 'lodash/get'
import FacebookIcon from 'components/icons/facebookWhite.svg'
import InstagramIcon from 'components/icons/instagramWhite.svg'
import LinkedinIcon from 'components/icons/linkedinWhite.svg'
import YoutubeIcon from 'components/icons/youtubeWhite.svg'
import TiktokIcon from 'components/icons/tiktokWhite.svg'
import TwitterIcon from 'components/icons/twitterWhite.svg'

const useBlogDetail = () => {
  const {
    post, siteName, socialLinks, relatedPosts = [],
  } = usePageProps()
  const router = useRouter()
  const currentUrl = `https://clikauto.com/${router.asPath}`
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down('lg'))
  const {
    content, title,
    _embedded, excerpt, date, acf,
  } = post
  const mediaImage = get(_embedded, 'wp:featuredmedia.0', {})
  // eslint-disable-next-line camelcase
  const { title: titleImage, source_url, media_details } = mediaImage
  const imageTitle = get(titleImage, 'rendered', '')

  const metaTitle = get(title, 'rendered', '')
  const descriptionMeta = get(excerpt, 'rendered', '')

  const head = (
    <Head>
      {metaTitle && <title>{[metaTitle, siteName].join(' | ')}</title>}
      {descriptionMeta && (
        <meta
          name="description"
          content={removeHtmlFromString(descriptionMeta)}
        />
      )}
    </Head>
  )

  const socialNetworks = [
    {
      href: socialLinks?.facebook,
      icon: <FacebookIcon />,
      alt: 'Facebook',
    },
    {
      href: socialLinks?.linkedin,
      icon: <LinkedinIcon />,
      alt: 'LinkedIn',
    },
    {
      href: socialLinks?.instagram,
      icon: <InstagramIcon />,
      alt: 'Instagram',
    },
    {
      href: socialLinks?.youtube,
      icon: <YoutubeIcon />,
      alt: 'Youtube',
    },
    {
      href: socialLinks?.twitter,
      icon: <TwitterIcon />,
      alt: 'Twitter',
    },
    {
      href: socialLinks?.tiktok,
      icon: <TiktokIcon />,
      alt: 'Tiktok',
    },
  ]

  const breadcrumbs = [
    {
      label: { id: 'BLOG', values: 'BLOG' },
      href: {
        id: '/blog',
        values: 'Blog',
      },
    },
    {
      label: get(title, 'rendered', ''),
      href: {
        id: router.asPath,
        values: get(title, 'rendered', ''),
      },
    },
  ]

  const imageWidth = !isMobile
    ? media_details?.width
    : media_details?.sizes?.thumbnail?.width
  const imageHeight = !isMobile
    ? media_details?.height
    : media_details?.sizes?.thumbnail?.height

  return {
    head,
    relatedPosts,
    currentUrl,
    content,
    imageTitle,
    imageWidth,
    imageHeight,
    date,
    title,
    source_url,
    post,
    descriptionMeta,
    metaTitle,
    isMobile,
    socialNetworks,
    breadcrumbs,
    acf,
  }
}

export default useBlogDetail
